import lib from '@/shared/lib';
import format from 'date-fns/format';
import isValid from 'date-fns/is_valid';

const { round } = lib;
const twoDecimals = round(2);

function convertDate(date) {
	if (!date) {
		return '';
	}
	const [day, month, year] = date.split('/');
	const result = `${year}-${month}-${day}`;
	const validDate = new Date(year, month, day);
	if (validDate.toString() === 'Invalid Date') {
		return '';
	}
	return result;
}

function formatDate(date, formatter = 'DD-MM-YYYY') {
	const newDate = format(new Date(date), formatter);
	return newDate;
}

function formatPaymentDate(date) {
	const currentDate = new Date();
	const hours = currentDate.getHours();
	const minutes = currentDate.getMinutes();
	const seconds = currentDate.getSeconds();
	const formatedDate = date
		? `${date} ${hours}:${minutes}:${seconds}`
		: format(new Date(), 'YYYY-MM-DD-HH-mm-ss');
	return formatedDate;
}

function generateBlob(data, contentType = 'application/pdf') {
	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::${key}`));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}`));
}

function getLocalToken() {
	return localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
}

function removeLocalData(key) {
	return localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::${key}`);
}

function setLocalData(key, data) {
	return localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${key}`, JSON.stringify(data));
}

function showDownloadDialog(blob, name, extension, download) {
	const currentDate = format(new Date(), 'YYYY-MM-DD');
	const link = document.createElement('a');
	link.download = `${name}_${currentDate}.${extension}`;
	const href = window.URL.createObjectURL(blob);
	link.href = href;
	document.body.appendChild(link);
	if (!download) {
		const iframe = document.createElement('iframe');
		document.body.appendChild(iframe);
		iframe.style.display = 'none';
		iframe.src = href;
		iframe.onload = () => {
			setTimeout(() => {
				iframe.focus();
				iframe.contentWindow.print();
			}, 100);
		};
	} else {
		link.click();
	}
	document.body.removeChild(link);
	window.URL.revokeObjectURL(href);
}
function showDownloadDialogOld(blob, name, extension) {
	const currentDate = format(new Date(), 'YYYY-MM-DD');
	const link = document.createElement('a');
	link.download = `${name}_${currentDate}.${extension}`;
	const href = window.URL.createObjectURL(blob);
	link.href = href;
	document.body.appendChild(link);
	// link.click();
	window.open(link.href);
	// if (!download) {
	// 	const iframe = document.createElement('iframe');
	// 	document.body.appendChild(iframe);
	// 	iframe.style.display = 'none';
	// 	iframe.src = href;
	// 	iframe.onload = () => {
	// 		setTimeout(() => {
	// 			iframe.focus();
	// 			iframe.contentWindow.print();
	// 		}, 1);
	// 	};
	// } else {
	// }
	document.body.removeChild(link);
	window.URL.revokeObjectURL(href);
}

/* eslint-disable */
function debounce(func, wait = 800, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function isValidDate(date) {
	return isValid(new Date(convertDate(date)));
}

function exactDate(date, formatter = 'DD-MM-YYYY', time, splitBy = 'T') {
	if (date) {
		const dateSplit = date.split(splitBy);
		const dateComplete = dateSplit[0].split('-');
		const timeComplete = dateSplit[1] ? dateSplit[1].split(':') : null;
		const year = dateComplete[0];
		const month = dateComplete[1] - 1;
		const day = dateComplete[2];
		const hour = timeComplete ? timeComplete[0] : null;
		const minutes = timeComplete ? timeComplete[1] : null;
		const seconds = timeComplete ? timeComplete[2].split('.')[0] : null;
		const newDate = !time || !timeComplete ? format(new Date(year, month, day), formatter) :
			format(new Date(year, month, day, hour, minutes, seconds), formatter);
		return newDate;
	}
	return '';
}

function quotesDistribution(amount, quotes) {
	let acc = 0;
	const quotesArr = [];
	for (let i = 0; i < quotes; i += 1) {
		const dif = amount - acc;
		const q = dif / (quotes - i);
		const qR = Math.ceil(q);
		acc += qR;
		quotesArr.push(qR)
	}
	if (acc > amount) {
		const lastQuote = quotesArr[quotes - 1]
		const excess = acc - amount;
		quotesArr[quotes - 1] = twoDecimals(lastQuote - excess);
	}
	return quotesArr;
}

function updateLocalStorage(key, data) {
	localStorage.removeItem(key);
	localStorage.setItem(key, JSON.stringify(data));
}

function simpledownloadFile(url, name, isDate = true) {
	const currentDate = format(new Date(), 'YYYY-MM-DD');
	const link = document.createElement('a');
	link.download = `${name}` + (isDate ? `_${currentDate}`:'');
	link.href = url;
	link.setAttribute('target', '_blank');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

const methods = {
	convertDate,
	debounce,
	exactDate,
	formatDate,
	formatPaymentDate,
	generateBlob,
	getLocalData,
	getLocalStorage,
	getLocalToken,
	isValidDate,
	removeLocalData,
	quotesDistribution,
	setLocalData,
	showDownloadDialog,
	showDownloadDialogOld,
	updateLocalStorage,
	simpledownloadFile,
};

export default methods;



// WEBPACK FOOTER //
// ./src/shared/helper.js